<template>
  <div class="colonnes-resp-full-4 tw-bg-blue-light evenement-side">
    <div class="colonnes-resp-3 padding-top-0-5 tw-flex-grow">
      <div class="tw-text-blue text-1-8 tw-font-bold tw-mb-6">
        Règles du jeu choisies
      </div>
        <div v-for="(regle, index) in contenu.acfEvent.reglesDuJeu" :key="index" class="text-1-8 tw-py-6 border-top">
            <span class="tw-w-8 tw-font-bold">
                     {{ index+1 }}.
            </span>
          {{ regle }}
        </div>
        <div v-if="contenu.acfEvent.olympiadeCulturelle" class="tw-text-pink tw-italic text-1-8 tw-pt-6 tw-mt-12 tw-mb-6">
            Cet évènement s’inscrit dans l’Olympiade Culturelle
        </div>
      </div>
    <SmallMap :marker="contenu"/>

  </div>
</template>

<script>
import SmallMap from "../../Map/SmallMap";
export default {
  name: "EventSide",
  components: {SmallMap},
  props : ['contenu']
}
</script>

<style lang="scss" scoped>

</style>